<div class="flex flex-col gap-2">
  <!-- ========= AUSBILDUNG ========= -->
  <p-card header="Ausbildungen">
    <div class="flex flex-col gap-2">
      @for (ausbildung of ausbildungen.controls; track ausbildung; let index = $index) {
        @if (isStudium(ausbildung)) {
          <app-studium [studiumFormGroup]="mapToStudiumFormGroup(ausbildung)" (remove)="removeAusbildung(index)"></app-studium>
        }
        @if (isLehre(ausbildung)) {
          <app-lehre [lehreFormGroup]="mapToLehreFormGroup(ausbildung)" (remove)="removeAusbildung(index)"></app-lehre>
        }
      }
    </div>
    <ng-template pTemplate="footer">
      <p-button outlined (click)="addAusbildung.toggle($event)" severity="primary" label="Ausbildung hinzufügen">
        <span class="material-symbols-outlined">add</span>
      </p-button>
      <p-menu #addAusbildung [model]="ausbildungPopupItems" [popup]="true" styleClass="popup-menu-width" />
    </ng-template>
  </p-card>

  <!-- ========= SCHULE ========= -->
  <p-card header="Schule*">
    <div class="flex flex-col gap-2">
      @if (ausbildungen.invalid && ausbildungen.touched && ausbildungen.errors && ausbildungen.errors['schuleRequired']) {
        <p-message severity="error">Bitte mindestens einen Eintrag zu Schule hinzufügen.</p-message>
      }
      @for (ausbildung of ausbildungen.controls; track ausbildung; let index = $index) {
        @if (isSchule(ausbildung)) {
          <app-schule [schuleFormGroup]="mapToSchuleFormGroup(ausbildung)" (remove)="removeAusbildung(index)"></app-schule>
        }
      }
    </div>
    <ng-template pTemplate="footer">
      <p-button outlined severity="primary" (click)="addSchule()" label="Schule hinzufügen">
        <span class="material-symbols-outlined">add</span>
      </p-button>
    </ng-template>
  </p-card>
</div>
